<template>
  <b-card title="Direction - Cellule">
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Rechercher</label>
          <b-form-input v-model="searchTerm" placeholder="Recherche" type="text" class="d-inline-block mr-1" />
          <b-button variant="primary" @click="openAddModal">
            <span class="text-nowrap">Ajouter</span>
          </b-button>
        </div>
      </b-form-group>
    </div>

    <vue-good-table :columns="columns" :rows="rows" :rtl="direction"
      :search-options="{enabled: true, externalQuery: searchTerm }"
      :pagination-options="{enabled: true,perPage: pageLength }">

      <template v-slot:table-row="props">
        <!-- Colonne : Nom -->
        <div v-if="props.column.field === 'name'" class="text-nowrap">
          {{ props.row.name }}
        </div>

        <!-- <div v-if="props.column.field === 'type'" class="text-nowrap">
          {{ props.row.type }}
        </div> -->

        <template v-else-if="props.column.field === 'active'">
          <b-badge :variant="statusVariant(props.row.active)">
            {{ props.row.active ? "Actif" : "Désactivé" }}
          </b-badge>
        </template>

        <span v-else-if="props.column.field === 'action'">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <more-vertical-icon size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item @click="openEditModal(props.row)">
              <edit-2-icon class="mr-50" />
              <span>Modifier</span>
            </b-dropdown-item>

            <b-dropdown-item v-if="props.row.isUsed"
              @click="deactivateDirectionsHandler(props.row.id, !props.row.active)">
              <ToggleLeftIcon class="mr-50" />
              <span>{{ props.row.active ? "Désactiver" : "Activer" }}</span>
            </b-dropdown-item>



            <b-dropdown-item v-else @click="deleteDirectionsHandler(props.row.id)">
              <trash-icon class="mr-50" />
              <span>Supprimer</span>
            </b-dropdown-item>

          </b-dropdown>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- Pagination -->
      <template v-slot:pagination-bottom="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">Affichage de 1 à</span>
            <b-form-select v-model="pageLength" :options="[3, 5, 10, 25, 50, 100, 200]" class="mx-1"
              @input="value => props.perPageChanged({ currentPerPage: value })" />
            <span class="text-nowrap">de {{ props.total }} Données</span>
          </div>
          <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
            align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
            @input="value => props.pageChanged({ currentPage: value })">
            <template #prev-text>
              <chevron-left-icon size="18" />
            </template>
            <template #next-text>
              <chevron-right-icon size="18" />
            </template>
          </b-pagination>
        </div>
      </template>
    </vue-good-table>

    <b-modal
    id="modal-prevent-closing"
      ref="my-modal"
    v-model="isModalActive"
    :title="modalTitle"

      @hidden="resetModal"
     @hide="resetModal"
      cancel-title="Fermer"
      cancel-variant="outline-secondary"
      @ok="handleOk">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <!-- Nom de la direction ou Cellule -->
        <b-form-group       ref="nameinput" :state="nameState" label="Intitulé"  label-for="name-input" invalid-feedback="Ce champ est requis.">
          <b-form-input  id="name-input" v-model="currentDirection.name" :state="nameState" required />
        </b-form-group>
        <b-form-invalid-feedback/>

        <b-form-group  label="Type" :state="typeState" invalid-feedback="Ce champ est requis.">
          <v-select v-model="currentDirection.type" :options="typeDirection" :state="typeState" required/>
        </b-form-group>
        <b-form-invalid-feedback />

      </form>
    </b-modal>

  </b-card>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BButton,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BPagination,
  BModal,
  BForm,
  BCard,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import {
  MoreVerticalIcon,
  Edit2Icon,
  TrashIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ToggleLeftIcon,
} from "vue-feather-icons";
import {
  allDirections,
  saveDirections,
  deleteDirections,
  updateDirections,
  updateDisabledDirection,
} from "@/services/DirectionsService";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
//import { ToggleLeftIcon, ToggleRightIcon } from "vue-feather-icons";
import vSelect from 'vue-select';

export default {
  components: {
    BCard,
    VueGoodTable,
    // BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BPagination,
    BModal,
    vSelect,
    MoreVerticalIcon,
    Edit2Icon,
    TrashIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ToggleLeftIcon,
    BFormInvalidFeedback,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      pageLength: 5,
      dir: false,
      columns: [
        { label: "Designation", field: "name" },
        { label: "Type", field: "type" },
        { label: "Statut", field: "active" },
        { label: "Action", field: "action" },
      ],
      rows: [],
      searchTerm: "",
      isModalActive: false,
      isEditMode: false,
      modalTitle: "",
      currentDirection: { name: "", active: false ,type: ""},
      typeDirection: ["Direction", "Pôle", "Cellule"],
      nameState: null,
      typeState:null,
    };
  },
  computed: {
    statusVariant() {
      return (status) => (status ? "light-primary" : "light-danger");
    },
    direction() {
      return this.dir;
    },
  },
  methods: {
    checkFormValidity() {
      this.nameState = this.currentDirection.name.trim() === "" ? false : null;
      this.typeState = !this.currentDirection.type ? false : null;

      return this.nameState === null && this.typeState === null;
    },
    validateName() {
      if (!this.currentDirection.name) return


      const forbiddenPatterns = [
            /<\s*\/?\s*[a-zA-Z][a-zA-Z0-9_-]*\s*.*?>/i,
            /<\s*script/i,
            /<\s*style/i,
            /on\w+\s*=/i,
            /(javascript|data|vbscript):/i,
            /(\$\{[^}]*\}|\{\{[^}]*\}\}|#\{[^}]*\})/,
            /(%3C|%3E|&#\d+;|&#x[0-9a-fA-F]+;|\\u[0-9a-fA-F]{4}|\\x[0-9a-fA-F]{2})/i,
          /<!--|--\>/
      ];
      return !forbiddenPatterns.some(pattern => pattern.test(this.currentDirection.name));
    },
    replaceString() {
      return  this.currentDirection.name.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    },

      openAddModal() {
      this.isEditMode = false;
      this.modalTitle = "Ajouter une direction";
      this.isModalActive = true;
    },
    openEditModal(direction) {
      this.isEditMode = true;
      this.modalTitle = "Modifier la direction";
      this.currentDirection = { ...direction };

      this.isModalActive = true;
    },
    resetModal() {
      this.currentDirection = { name: "", active: false ,type:""};
      this.nameState = null
      this.typeState = null

    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    async handleSubmit() {
      if (!this.checkFormValidity() || !this.validateName()) return;
      try {
        if (this.isEditMode) {
          const updatedDirection = await updateDirections(
            this.currentDirection.id,
            this.currentDirection
          );
          const index = this.rows.findIndex(
            (row) => row.id ===updatedDirection.id
          );

          if (index !== -1) Object.assign(this.rows[index], updatedDirection);
          this.showToast("Direction modifié avec succès.", "success");
          this.resetModal();
          this.isModalActive = false;
        } else {
          const newDirection = await saveDirections(this.currentDirection);
          this.rows.push(newDirection);
          this.showToast("Direction ajouté avec succès.", "success");
          this.resetModal();
        }
        //  this.isModalActive = false;
      } catch (error) {
        console.error("Error saving data:", error);
      }
    },
    async deleteDirectionsHandler(directionId) {
      try {
        await deleteDirections(directionId);
        this.rows = this.rows.filter((row) => row.id !== directionId);
        this.showToast("Directions supprimé avec succès.","success");

      } catch (error) {
        console.error("Error deleting data:", error);
        this.showToast("Échec lors de la suppression.", "danger");

      }
    },
    async deactivateDirectionsHandler(directionId, active) {
      try {
        const updatedDirection = await updateDisabledDirection(directionId, {
          active,
        });
        const row = this.rows.find((r) => r.id === directionId);
        if (row) Object.assign(row, updatedDirection);

        this.showToast(`Directions ${active ? 'activé' : 'désactivé'} avec succès.`,"success");

      } catch (error) {
        this.showToast(`Échec de la mise à jour du statut.`,"danger");

       // console.error('Error fetching data:', error);
      }
    },
    showToast(message,color) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: "CheckCircleIcon",
          variant: color,
        },
      });
    },
  },
  async mounted() {
    try {
      this.rows = await allDirections();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~vue-good-table/dist/vue-good-table.css";
@import '@core/scss/vue/libs/vue-select.scss';

</style>

